// import BMap from 'BaiduMap'  // 百度地图导入

// // 百度地图获取城市名称的方法
// let getCurrentCityName = function() {
//   return new Promise(function(resolve, reject) {
//     let myCity = new BMap.LocalCity()
//     myCity.get(function(result) {
//       resolve(result.name)
//     })
//   })
// }
///////利用高德地图获取城市信息
let getCurrentCityName = function() {
  return new Promise(function(resolve, reject) {
    // var map = new AMap.Map('container', {
    //   resizeEnable: true,
    //   center: [116.397428, 39.90923],
    //   zoom: 13
    // })
    //获取用户所在城市信息  方法定义
    function showCityInfo() {
      //实例化城市查询类
      var citysearch = new AMap.CitySearch()
      //自动获取用户IP，返回当前城市
      citysearch.getLocalCity(function(status, result) {
        if (status === 'complete' && result.info === 'OK') {
          if (result && result.city && result.bounds) {
            var cityinfo = result.city
            // var citybounds = result.bounds
            console.log(cityinfo)
            console.log(result)
            resolve(cityinfo) ////获取成功  扔出城市信息
            // document.getElementById('info').innerHTML =
            //   '您当前所在城市：' + cityinfo
            // //地图显示当前城市
            // map.setBounds(citybounds)
          }
        } else {
          // document.getElementById('info').innerHTML = result.info
          console.log(result.info)
          reject(result.info) ////获取失败扔出失败信息
        }
      })
    }
    showCityInfo() ///执行方法

    

  })
}

export default getCurrentCityName
